import 'twin.macro'

import { Ring } from '@uiball/loaders'
import CountdownTimer from 'components/UI/Timer'
import Typography from 'components/UI/Typography'
import { useTranslation } from 'react-i18next'

type UpgradeConditionStateProps = {
  stepStatus: boolean
}

const UpgradeConditionState = ({ stepStatus }: UpgradeConditionStateProps) => {
  // Tools
  const { t } = useTranslation()

  const lang = localStorage.getItem('i18nextLng')

  if (!stepStatus) return null
  return (
    <div tw='flex items-center space-x-6 px-5 mt-4 pb-5'>
      <span tw='flex-shrink-0'>
        <Ring size={24} color='var(--primary-color)' />
      </span>
      <div>
        {lang === 'ru' ? (
          <Typography variant='subbody'>
            Проводится анализ ваших документов. Процесс может занять <br /> до{' '}
            <CountdownTimer initialMinutes={15} initialSeconds={0} showText={false} />
          </Typography>
        ) : lang === 'kk' ? (
          <Typography variant='subbody'>
            <span>Сіздің құжаттарыңыз талдануда. Процесс</span>{' '}
            <CountdownTimer initialMinutes={15} initialSeconds={0} showText={false} />
            <span> дейін созылуы мүмкін</span>
          </Typography>
        ) : null}
        <Typography variant='caption' tw='text-grey-dark mt-1'>
          {t('flow-wait-sms')}
        </Typography>
      </div>
    </div>
  )
}

export default UpgradeConditionState
